import Vue from 'vue'
import toggoleMore from './modules/toggoleMore'
import money from './modules/money'

Vue.directive('toggole-more', toggoleMore)
Vue.directive('money', money)
